module.exports = __webpack_public_path__ + "img/bg.44491299.svg";